import React from "react";
import {
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  View,
  Text,
  SafeAreaView,
  Platform,
} from "react-native";

import { isEUCountry, isWeb, navigate } from "../helpers/utils";

import Markdown from "../controls/Markdown";
import RoundCheckbox from "./v3/common/RoundCheckbox";
import appStyles from "./appStyles";
import AppTheme from "./v3/AppTheme";
import ManaButton from "./v3/common/ManaButton";
import appPages from '../appPages';

const termsGlobal = require("../assets/terms/Global.js").default;
const termsEU = require("../assets/terms/EU.js").default;

export default class PageTerms extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.country = props.country;

    this.state = {
      checkedTerms: false,
      read: true,
      checked18: false,
      checkedUpdates: true,
    };
  }

  updateSettings = (key) => {
    const { read } = this.state;

    if (!read) return;
    this.setState({ [key]: !this.state[key] });
  };

  isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
    const paddingToBottom = 160;

    if (
      layoutMeasurement.height + contentOffset.y >=
      contentSize.height - paddingToBottom
    ) {
      this.setState((state) => ({ ...state, read: true }));
    }
  };

  onNext() {
    const { checkedTerms, checked18, checkedUpdates } = this.state;
    if (!checkedTerms || !checked18) return;

    const action = {
      action: "save",
      target: "terms",
      screen: "feed",
      page: "home",
      agree: "1",
      terms_type: isEUCountry(this.country) ? "EU" : "Global",
      is18orOlder: "1",
      receiveUpdates: checkedUpdates ? "1" : "0",
    };

    this.controller.tracking.track("Accept Terms");
    console.log("Accept terms");
    this.controller.cardActionWithCallback(action, () => {
      if (this.controller.settings == null) {
        this.controller.settings = { terms_agreed: true };
      } else {
        this.controller.state.settings.terms_agreed = true;
      }
      navigate(this.controller, appPages.onboardingInfoPage);
    });
  }

  render() {
    const { checkedTerms, checked18, checkedUpdates } = this.state;

    return (
      <SafeAreaView
        style={[appStyles.container, { paddingTop: isWeb ? 30 : 0 }]}
      >
        <ScrollView
          style={appStyles.scrollView}
          contentContainerStyle={[
            appStyles.scrollViewContent,
            styles.termsText,
          ]}
          //onScroll={({ nativeEvent }) => this.isCloseToBottom(nativeEvent)}
        >
          <Markdown>
            {isEUCountry(this.country) ? termsEU : termsGlobal}
          </Markdown>
        </ScrollView>

        <View style={[appStyles.footerOptions, styles.controls]}>
          {/* Terms */}
          <TouchableOpacity
            onPress={() => this.updateSettings("checkedTerms")}
            style={[styles.textContainer]}
          >
            <RoundCheckbox
              size={16}
              checked={checkedTerms}
              onValueChange={() => this.updateSettings("checkedTerms")}
            />
            <Text style={styles.agreedText}>
              I have read the terms of service and agree to be bound by them
            </Text>
          </TouchableOpacity>

          {/* Checked18 */}
          <TouchableOpacity
            onPress={() => this.updateSettings("checked18")}
            style={[styles.textContainer]}
          >
            <RoundCheckbox
              size={16}
              checked={checked18}
              onValueChange={() => this.updateSettings("checked18")}
            />
            <Text style={styles.agreedText}>I am 18 years old or older</Text>
          </TouchableOpacity>

          {/* Marketing */}
          <TouchableOpacity
            style={[styles.textContainer]}
            onPress={() => this.updateSettings("checkedUpdates")}
          >
            <RoundCheckbox
              size={16}
              checked={checkedUpdates}
              onValueChange={() => this.updateSettings("checkedUpdates")}
            />
            <Text style={styles.agreedText}>
              I want to receive updates about new features & time management
              tips
            </Text>
          </TouchableOpacity>

          <View style={{ justifyContent: "center", flexDirection: "row" }}>
            <ManaButton
              disabled={!checkedTerms || !checked18}
              onPress={() => this.onNext()}
              style={styles.button}
              styleText={styles.buttonText}
              text="Continue"
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  controls: {
    backgroundColor: "#F3F2F1",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    paddingBottom: 30,
    bottom: 0,
  },
  termsText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    color: AppTheme.almostBlack,
  },
  textContainer: {
    height: 50,
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,0.1)",
    paddingLeft: 16,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  agreedText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    maxWidth: "70%",
    marginLeft: 11,
  },
  button: {
    backgroundColor: AppTheme.DEFAULT_COLOR,
    width: 200,
    height: 40,
    borderRadius: 6,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.4,
    shadowColor: "rgba(0,0,0, 0.25)",
    shadowRadius: 3,
    marginTop: 14,
    maxWidth: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#FFF",
    textAlign: "center",
  },
});
